import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPause"><Path d="M4 3H10V21H4V3Z" fill="currentColor"/><Path d="M14 3H20V21H14V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPause;
